import saga from 'Modules/accountInfo/store/saga'
import reducer from 'Modules/accountInfo/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelectAccountInfo } from 'Modules/accountInfo/store/selectors'
import { getAccountInfo, updateAccountInfoBasic, updateAccountInfoBusiness } from 'Modules/accountInfo/store/actions'

export const useAccountInfo = () => {
  useInjectSaga({ key: 'accountInfo', saga })
  useInjectReducer({ key: 'accountInfo', reducer })

  const { accountInfo } = useSelector(
    makeSelectAccountInfo()
  )

  const dispatch = useDispatch()
  const getAccountInfoAction = (payload) => dispatch(getAccountInfo(payload))
  const updateAccountInfoBasicAction = (payload) => dispatch(updateAccountInfoBasic(payload))
  const updateAccountInfoBusinessAction = (payload) => dispatch(updateAccountInfoBusiness(payload))

  return {
    accountInfo,
    getAccountInfoAction,
    updateAccountInfoBasicAction,
    updateAccountInfoBusinessAction
  }
}
